import script from "./ResourceActionsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ResourceActionsPage.vue?vue&type=script&setup=true&lang=js"

import "./ResourceActionsPage.vue?vue&type=style&index=0&id=5c52d830&scoped=true&lang=scss"
/* custom blocks */
import block0 from "./ResourceActionsPage.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c52d830"]])

export default __exports__